/**
 * Description: 表情提示
 * User: 暁麦
 * Date: 16/01/23
 * Copyright(c) 2016 Taobao.com
 */
import $ from '@ali/tarzan-zepto';
import smiley from '@ali/tarzan-smiley';
import tpl from './tpl.html';
import './style.scss';

let $node = null;
let timer = null;

function getPicByText(text) {
  let pic = null;
  smiley.XIAO_MI.forEach((t) => {
    if (t[0] === text) {
      pic = t[1];
    }
  });
  return pic;
}

function destorySmileytip() {
  if ($node) {
    $node.remove();
    $node = null;
    clearTimeout(timer);
  }
}

function bindEvent(text, onClickSmiley) {
  $node.on('tap', (ev) => {
    onClickSmiley(`[xm:${text}]`);
    destorySmileytip();
    ev.stopPropagation();
  });

  // 点body其他地方，隐藏表情
  $('body').off('tap').on('tap', () => {
    destorySmileytip();
  });
}

function smileytip(text, onClickSmiley) {
  // 渲染前，先删掉上一次的渲染
  destorySmileytip();

  // 根据文本取对应的表情url
  const pic = getPicByText(text);

  // 如果取到了
  if (pic) {
    const data = {
      pic,
      text,
    };
    $node = $(tpl.render(data));
    $('body').append($node);

    // 5s之后删除
    timer = setTimeout(() => {
      destorySmileytip();
    }, 5000);

    // 绑定点击事件
    bindEvent(text, onClickSmiley);
  }
}

export {
  smileytip, destorySmileytip,
};



// WEBPACK FOOTER //
// ./src/component/view/footer/smileytip/index.js